module.exports = __webpack_public_path__ + "static/media/63.54448a17.jpg";